<template>
    <div
        class="flex flex-col items-center justify-center border-t border-gray-325"
    >
        <div class="mx-auto w-8 border-b-3 border-primary-525"></div>
        <div class="my-4 w-full px-4">
            <div class="flex items-center justify-between">
                <div class="w-20 text-left">
                    <div
                        :class="
                            'inline-block rounded border border-gray-325 px-2 py-1 text-gray-625' +
                            ' ' +
                            (this.currentPage === 1
                                ? 'opacity-50 hover:cursor-not-allowed'
                                : 'hover:cursor-pointer hover:bg-gray-300')
                        "
                        @click="goToPrevPage()"
                    >
                        Prev<span class="hidden md:inline">ious</span>
                    </div>
                </div>
                <div class="flex flex-grow items-center gap-2">
                    <div
                        class="flex-shrink hover:cursor-pointer hover:underline"
                        @click="goToSelectedPage(1)"
                        v-if="showLowerLimit"
                    >
                        1&nbsp;&hellip;
                    </div>
                    <div class="flex-grow"></div>
                    <div
                        class="flex-shrink hover:cursor-pointer hover:underline"
                        v-for="page in pageNumbersArray"
                        @click="goToSelectedPage(page)"
                    >
                        <span
                            :class="
                                currentPage === page
                                    ? 'font-semibold text-primary-525'
                                    : ''
                            "
                        >
                            {{ page }}</span
                        >
                    </div>
                    <div class="flex-grow"></div>
                    <div
                        class="flex-shrink hover:cursor-pointer hover:underline"
                        v-if="showUpperLimit"
                        @click="goToSelectedPage(totalPages)"
                    >
                        &hellip;&nbsp;{{ totalPages }}
                    </div>
                </div>
                <div class="w-20 text-right">
                    <div
                        :class="
                            'inline-block rounded border border-gray-325 px-2 py-1 text-gray-625' +
                            ' ' +
                            (this.currentPage === this.totalPages
                                ? 'opacity-50 hover:cursor-not-allowed'
                                : 'hover:cursor-pointer hover:bg-gray-300')
                        "
                        @click="goToNextPage()"
                    >
                        Next
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ContentPaginator",
    emits: ["go-to-page"],
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        totalPages: {
            type: Number,
            default: 1,
        },
    },
    methods: {
        goToPrevPage() {
            if (this.currentPage === 1) {
                return;
            }
            this.$emit("go-to-page", this.currentPage - 1);
        },
        goToNextPage() {
            if (this.currentPage === this.totalPages) {
                return;
            }
            this.$emit("go-to-page", this.currentPage + 1);
        },
        goToSelectedPage(pageNumber) {
            this.$emit("go-to-page", pageNumber);
        },
    },
    computed: {
        pageNumbersArray() {
            let pageNumbers, midIndex;

            pageNumbers = _.range(1, this.totalPages + 1);
            midIndex = Math.round(this.currentPage - 3);

            if (midIndex - 1 > 0) {
                pageNumbers.splice(0, midIndex + 1);
            }

            pageNumbers.splice(5, pageNumbers.length - 5);

            return pageNumbers;
        },
        showUpperLimit() {
            return !_.includes(this.pageNumbersArray, this.totalPages);
        },
        showLowerLimit() {
            return !_.includes(this.pageNumbersArray, 1);
        },
    },
};
</script>
